/* global FB */
/* global PinUtils */
/* global __SERVER_VAR_FACEBOOK_ID__ */
/*
Generates Social Media Share button
@param type: (string, required), facebook | twitter | pinterest | tumblr
@param url: (string, required), a valid url to be shared
@param buttonText: (string, required), desired text to appear on the button
@param description: (string, required), text description content to be shared
@param image: (string, optional), Image url used by pinterest
*/
import React, {Fragment} from 'react'
import { string } from 'prop-types'
import {isClient, insertScript, toTitleCase} from 'scripts/lib/utils'

const FB_SCRIPT_STRING = `(function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'))`

const TW_INTENT_URL = `https://twitter.com/intent/tweet/?text=DESCRIPTION&url=URL&via=soompi`
const P_SCRIPT_URL = `https://assets.pinterest.com/js/pinit.js`
const T_SHARE_URL = `https://tumblr.com/widgets/share/tool?canonicalUrl=URL&title=DESCRIPTION`

export const propError = (props, propName, componentName) => {
  return new Error('Property ' + propName + ' is required for type: ' + props['type'] + ' supplied to ' + componentName)
}

class SocialShare extends React.Component {
  button = null
  static propTypes = {
    type: string.isRequired,
    description: (props, propName, componentName) => {
      if (props['type'] !== 'facebook' && typeof props[propName] === 'undefined') {
        return propError(props, propName, componentName)
      }
    },
    url: string.isRequired,
    buttonText: string.isRequired,
    image: (props, propName, componentName) => {
      if (props['type'] === 'pinterest' && typeof props[propName] === 'undefined') {
        return propError(props, propName, componentName)
      }
    }
  }

  windowOpener = (url) => {
    const width = 560
    const height = 400
    const top = 100
    const left = (screen.width / 2) - (width / 2)
    const options = `width=${width},height=${height},titlebar=no,toolbar=no,top=${top},left=${left}`
    window.open(url, 'soompi-sharer', options)
  }

  genericPopup = (popupURL) => {
    if (!isClient()) { return null }
    const {url, description} = this.props
    const shareURL = encodeURIComponent(url)
    const openerURL = popupURL.replace('DESCRIPTION', (description || '')).replace('URL', shareURL)
    this.windowOpener(openerURL)
  }

  generateButton = (onClick) => {
    const {type, buttonText} = this.props
    return <a href="javascript:;"
      className={`btn btn-unicorn btn-share btn-share-${type.toLowerCase()}`}
      onClick={onClick}><span className={`icon icon-${type.toLowerCase()}`} /> {buttonText}</a>
  }

  facebookOnClick = () => {
    if (typeof FB === 'undefined') { return null }
    FB.ui({
      method: 'share',
      display: 'popup',
      href: this.props.url
    })
  }

  pinterestOnClick = () => {
    if (typeof PinUtils === 'undefined') { return null }
    const {url, image, description} = this.props
    PinUtils.pinOne({
      media: (image || ''), url, description: (description || '')
    })
  }

  generateFacebook = () => {
    if (isClient()) {
      const body = document.body
      window.fbAsyncInit = () => {
        FB.init({
          appId: __SERVER_VAR_FACEBOOK_ID__,
          status: true,
          xfbml: true,
          version: 'v3.0'
        })
      }
      const fbroot = document.createElement('div')
      const script = document.createElement('script')
      fbroot.id = 'fb-root'
      script.innerHTML = FB_SCRIPT_STRING
      body.appendChild(fbroot)
      body.appendChild(script)
    }
    return this.generateButton(() => {
      this.facebookOnClick()
    })
  }

  generateTwitter = () => {
    return this.generateButton(() => {
      this.genericPopup(TW_INTENT_URL)
    })
  }

  generatePinterest = () => {
    if (isClient()) {
      const body = document.body
      insertScript(P_SCRIPT_URL, 'pinterest-js', body)
    }
    return this.generateButton(() => {
      this.pinterestOnClick()
    })
  }

  generateTumblr = () => {
    return this.generateButton(() => {
      this.genericPopup(T_SHARE_URL)
    })
  }

  render() {
    const fnName = `generate${toTitleCase(this.props.type)}`
    if (typeof this[fnName] === 'undefined') {
      return null
    }
    return (
      <Fragment>{this[fnName]()}</Fragment>
    )
  }
}

export default SocialShare



// WEBPACK FOOTER //
// ./assets/js/helpers/SocialShare.jsx